import React from "react";

export default function Arrow() {
  return (
    <>


        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 4.75195C0 4.47581 0.223858 4.25195 0.5 4.25195L12.2929 4.25195L9.14645 1.10551C8.95118 0.910245 8.95118 0.593661 9.14645 0.398399C9.34171 0.203136 9.65829 0.203136 9.85355 0.398399L13.8536 4.3984C14.0488 4.59366 14.0488 4.91024 13.8536 5.10551L9.85355 9.10551C9.65829 9.30077 9.34171 9.30077 9.14645 9.10551C8.95118 8.91024 8.95118 8.59366 9.14645 8.3984L12.2929 5.25195L0.5 5.25195C0.223858 5.25195 0 5.0281 0 4.75195Z" />
        </svg>



    </>
  );
}
